import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import Box from '@zenbusiness/zui/Box';
import { superstyled, useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import { VeloAssistantButton } from '#client/components/VeloAssistantButton';
import { useVeloPanel } from '#client/components/VeloSidePanel/hooks/useVeloPanel';
import { buildVeloPageUrl } from '#client/components/VeloSidePanel/utils/buildVeloPageUrl';

const FloatingContainer = superstyled({
  name: 'FloatingVeloButtonContainer',
  tag: Box,
  styles: () => ({
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 1000,
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    // Ensure it doesn't interfere with interactions
    pointerEvents: 'none',
    '& > *': {
      pointerEvents: 'auto',
    },
  }),
});

function FloatingVeloButton() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { businessEntityUuid } = useBusinessEntity();
  const { page, isPanelVisible, openPanel } = useVeloPanel();

  if (isPanelVisible) {
    return null;
  }

  const isReopenButton = !!page && !isMobile;
  const pageUrl = page && isMobile && businessEntityUuid ? buildVeloPageUrl(businessEntityUuid, page) : undefined;
  const clickstreamProps = {
    elementName: 'floating_velo_assistant_button',
    elementPosition: 'bottom_right_floating',
    ...(isReopenButton ? { elementText: 'open_velo_side_panel' } : {}),
  };

  return (
    <FloatingContainer>
      <VeloAssistantButton
        variant="outlined"
        color="primary"
        avatarColor="#FAFAFA"
        iconOnly
        url={pageUrl}
        onClick={isReopenButton ? openPanel : undefined}
        clickstreamProps={clickstreamProps}
      />
    </FloatingContainer>
  );
}

export default FloatingVeloButton;
